import axios from 'axios';

/**
 * Send a post request to update which method is used by user.
 * @param {String} methodName, the name of the method that has been used by the user.
 * @param {String} serviceName, the name of the application/website that has been used by the user.
 * @param {String} label, additional information of this request
 */
const postUsage = (methodName, serviceName="bioinformatics-hub", label="") => {
  const baseUrl = "https://usage-checker.herokuapp.com/stats";
  axios.post(baseUrl, {methodName, serviceName, label} ).then(res => {
    console.log(res.data);
  });
}

export default postUsage;